// extracted by mini-css-extract-plugin
export default {"btn-primary":"_label_btn-primary__M13Ep","label":"_label_label__-nvUB","medium":"_label_medium__zkYId"};